"use client";

import { theme } from "@/config/theme";
import { SCContainerContent } from "@/utils/styledComponents";
import { useTranslations } from "next-intl";
import styled from "styled-components";
import EmblaCarousel from "./Component-EmblaCarousel-CustomerReviews";
import { EmblaOptionsType } from "embla-carousel";
import iconSg from "/public/media/images/icon-country-flag-sg.png";

const CustomerReviews = () => {
    const t = useTranslations("CustomerReviews");

    const reviewList = [
        {
            title: "Dedicated and Professional Coaches",
            review: "“I am incredibly grateful to two amazing coaches, Fabian and Williams, for guiding my daughter to win a gold medal in the SwimSafer program. Coach Fabian, as the head coach, is highly dedicated and professional, with a strong focus on swimming techniques. He goes the extra mile to ensure the kids learn the proper strokes. Coach Williams is very patient and well-liked by the children, especially those who are afraid of water. A heartfelt thank you to both coaches! If you’re thinking of enrolling your child in swimming lessons, don’t hesitate.”",
            reviewer: "Joe Gan",
            country: t("Singapore"),
            flag: iconSg
        },
        {
            title: "Effective Teaching for All Levels",
            review: "“My two children are at different levels, but they train in the same class, which saves me a lot of time. My youngest is motivated by her older sibling to swim better. I’ve tried other swimming classes before, but my kids never made much progress. In those classes, the children just waited their turn to be taught. With Coach Ben, all the kids learn simultaneously. My children have improved so quickly, and I’m really grateful to Coach Ben!”",
            reviewer: "May Wei Lai",
            country: t("Singapore"),
            flag: iconSg
        },
        {
            title: "Confidence in a Short Time",
            review: "“I highly recommend The Swim Starter for children who lack confidence in the water. In less than three months, my daughter can now swim without a float. She feels comfortable and has a lot of trust in Coach Denver, who is an excellent instructor. Thank you, Coach Denver! We’re excited to continue with my daughter’s swimming lessons. Her confidence grows every day!”",
            reviewer: "Shasha Rashid",
            country: t("Singapore"),
            flag: iconSg
        },
        {
            title: "Personalized Approach for Every Child",
            review: "“We highly recommend The Swim Starter. We’re from France and are only temporarily living in Singapore. Coach Ben has proven to be a patient and experienced coach, and we saw results very quickly. Our younger child also wanted to join, and we were allowed to enroll them in the same class as their sibling. Despite their limited English, Ben found an effective approach to teach both of them. We’re incredibly grateful and recommend these classes to everyone.”",
            reviewer: "Koptyug Irina",
            country: t("Singapore"),
            flag: iconSg
        }
    ];

    const OPTIONS: EmblaOptionsType = { loop: true };
    const SLIDES = reviewList;

    return (
        <SCCustomerReviews>
            <SCCustomerReviewsContent>
                {/* <div className="text-container">
                    <div className="text-largexlarge">{t("title-text")}</div>
                    <div className="text-medium">{t("description-text")}</div>
                </div> */}
                <EmblaCarousel slides={SLIDES} options={OPTIONS} />
            </SCCustomerReviewsContent>
        </SCCustomerReviews>
    );
};

export default CustomerReviews;

const SCCustomerReviews = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: ${theme["color-light-yellow"]};
    padding: ${theme["spacing-lxl"]} 0;
`;

const SCCustomerReviewsContent = styled(SCContainerContent)`
    display: flex;
    flex-direction: column;
    height: 80%;

    .text-container {
        margin-bottom: ${theme["spacing-l"]};

        .text-largexlarge {
            font-size: ${theme["fontsize-lxl"]};
            font-weight: 500;
            margin-bottom: ${theme["spacing-m"]};
        }

        .text-medium {
            font-size: ${theme["fontsize-m"]};
            color: ${theme["color-grey"]};
        }
    }

    // .embla {
    //     overflow: hidden;
    // }
    // .embla__container {
    //     display: flex;
    // }
    // .embla__slide {
    //     flex: 0 0 100%;
    //     min-width: 0;
    // }
`;
